import { AI_PROMPT_TYPE } from 'services/ai/constants'

export const OBSERVATION_AI_PROMPT_TYPE = {
  ...AI_PROMPT_TYPE,
  IMPROVE_WRITING: 'observation_improve_writing',
}
